import { MaybeObservable } from "flow/interfaces/MaybeObservable";
import ko from "knockout";
import viewHtml from "./ko-persistent-notification.html";
import PersistentNotificationTypeEnum, {
    getPersistentNotificationTypeClass
} from "flow/enums/PersistentNotificationTypeEnum";
import { makeObservableIfNeeded } from "flow/koHelpers/makeObservable";

export interface IPersistentNotificationParams {
    type: MaybeObservable<PersistentNotificationTypeEnum>;
    icon: MaybeObservable<string>;
    text: MaybeObservable<string>;
}

ko.components.register("ko-persistent-notification", {
    viewModel: function (params: IPersistentNotificationParams) {
        this.badgeClass = ko.pureComputed(() => getPersistentNotificationTypeClass(ko.unwrap(params.type)));
        this.text = makeObservableIfNeeded(params.text, "");
        this.icon = params.icon;
    },
    template: viewHtml,
    synchronous: true
});
